/**
 * sticky filter button
 */
export function stickFilterButtonInit() {
    const stickyFilterAnchor = document.querySelector('.js-sticky-filter-anchor')
    const stickyFilterButton = document.querySelector('.btn-filter')

    const handler = (entries) => {
        let entry = entries[0];

        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            stickyFilterButton?.classList.add('btn-filter--sticky');
        } else {
            stickyFilterButton?.classList.remove('btn-filter--sticky');
        }
    }

    const observer = new window.IntersectionObserver(handler)
    if (stickyFilterAnchor) {
        observer.observe(stickyFilterAnchor);
    }
}
